export default __webpack_public_path__ + "static/artifakt-element-medium-b994c2ffd8556a63317bafd1d2f7c36e.woff2";